import { initContactForm } from './forms/initContactForm';
import { initCreateAccountEmail } from './forms/initCreateAccountEmail';
import { initEmailAutocompleteDropdown } from '../../../../../Common/Resources/templates/components/EmailAutocompleteDropdown/initEmailAutocompleteDropdown';

export const initForms = () => {
    initEmailAutocompleteDropdown();
    initContactForm();
    initCreateAccountEmail();
};
